module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-fix-fouc/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-nprogress/gatsby-browser.js'),
      options: {"plugins":[],"color":"#3498db","showSpinner":false},
    },{
      plugin: require('../node_modules/gatsby-plugin-react-i18next/gatsby-browser.js'),
      options: {"plugins":[],"localeJsonSourceName":"locale","languages":["en","fa"],"defaultLanguage":"en","siteUrl":"https://sadegh-zr.github.io/immediate-inference","generateDefaultLanguagePage":true,"i18nextOptions":{"interpolation":{"escapeValue":false},"keySeparator":false,"nsSeparator":false}},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Immediate Inference","short_name":"Immediate Inf.","start_url":"/","description":"Get all true statements from your inputed statement using immediate inference in logic","background_color":"#fff","lang":"en","theme_color":"#3498db","display":"standalone","icon":"./src/images/icon.svg","icon_options":{"purpose":"any maskable"},"localize":[{"start_url":"/fa/","lang":"fa","name":"قضایای مباشر","short_name":"قضایای مباشر","description":"تمام قضایای صحیح را به وسیله استدلال مباشر منطقی از قضیه مد نظر خود بدست آورید"}],"legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"a774c80c2055eb0bdf4c5d7a33aa3248"},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
